import { useContext } from 'react';
import StoreContext from '../contexts/StoreContext';

const useStoreContext = () => useContext(StoreContext);

export default useStoreContext;
